/**
 * Theme Toggle - Dark/Light Mode
 * Drew Davis Fine Art Shopify Theme
 *
 * Default: dark mode for all visitors
 * Manual toggle saves preference to localStorage
 */

class ThemeToggle {
  constructor() {
    this.toggleButtons = document.querySelectorAll('[data-theme-toggle]');
    this.storageKey = 'theme-mode';
    this.darkModeClass = 'dark-mode';

    this.init();
  }

  init() {
    // Bind click handlers
    this.toggleButtons.forEach(button => {
      button.addEventListener('click', () => this.toggle());
    });

    // Default to dark mode if no preference saved
    if (!localStorage.getItem(this.storageKey)) {
      this.setTheme('dark', false);
    }

    // Update button states
    this.updateButtonStates();
  }

  /**
   * Toggle between light and dark mode
   */
  toggle() {
    const isDark = document.documentElement.classList.contains(this.darkModeClass);
    this.setTheme(isDark ? 'light' : 'dark', true);
  }

  /**
   * Set the theme
   * @param {string} mode - 'light' or 'dark'
   * @param {boolean} savePreference - whether to save as manual preference
   */
  setTheme(mode, savePreference = true) {
    if (mode === 'dark') {
      document.documentElement.classList.add(this.darkModeClass);
    } else {
      document.documentElement.classList.remove(this.darkModeClass);
    }

    if (savePreference) {
      localStorage.setItem(this.storageKey, mode);
    }

    this.updateButtonStates();
  }

  /**
   * Update toggle button states
   */
  updateButtonStates() {
    const isDark = document.documentElement.classList.contains(this.darkModeClass);

    this.toggleButtons.forEach(button => {
      button.setAttribute('aria-pressed', isDark.toString());
      button.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to dark mode');
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.themeToggle = new ThemeToggle();
  });
} else {
  window.themeToggle = new ThemeToggle();
}
